export const SOCKET_EVENTS = {
  startCheck: "startCheck",
  checkDone: "checkDone",
  startVideoCheck: "startVideoCheck",
  checkVideoDone: "checkVideoDone",
  startAgentCheck: "startAgentCheck",
  checkAgentDone: "checkAgentDone",
  register: "register",
  unregister: "unregister",
  connect: "connect",
  reconnect: "reconnect",
  connect_error: "connect_error",
  disconnect: "disconnect",

  updateActiveIds: "updateActiveIds",

  users_list: "users:list",
  users_list_update: "users:list:update",
  // users_offline: "users:offline",
  // users_online: "users:online",

  documents: {
    create: {
      success: "documents:create:success",
      error: "documents:create:error"
    }
  },
}